<template>
  <section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col
        xl="4"
        md="6"
      >
        <UserCardLandingPage />
      </b-col>
      <b-col
        xl="8"
        md="6"
      >
        <PFICreditLimitOverview />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        xl="12"
        md="12"
      >
        <SFATracker />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="5">
        <b-row class="match-height">
          <b-col
            lg="12"
            md="12"
            cols="12"
          >
            <FavoriteWidget />
          </b-col>

        </b-row>
      </b-col>
      <b-col lg="7">

        <b-col
          lg="12"
          md="12"
        >
          <PFIQuickLinksWidget />
        </b-col>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { useActions } from 'vuex-composition-helpers'
import { onMounted } from '@vue/composition-api'
import UserCardLandingPage from './UserCardLandingPage.vue'
import PFICreditLimitOverview from './PFICreditLimitOverview.vue'
import SFATracker from './SFATracker.vue'
import FavoriteWidget from './FavoriteWidget.vue'
import PFIQuickLinksWidget from './PFIQuickLinksWidget.vue'
import { dashboardPermissions } from '../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,
    UserCardLandingPage,
    PFICreditLimitOverview,
    FavoriteWidget,
    PFIQuickLinksWidget,
    SFATracker,
  },
  setup() {
    const {
      getTillAccountList,
      getVaultAccountList,
      getBranches,
      getBanks,
      getIncomeGLAccount,
      getIncomeGLByParentCategory,
      getStationaryAccount,
      getCurrentFinancialDate,
      getCorporateInformation,
    } = useActions({
      getTillAccountList: 'operations/getTillAccountList',
      getVaultAccountList: 'operations/getVaultAccountList',
      getBranches: 'operations/getAllBranches',
      getBanks: 'operations/getBanks',
      getIncomeGLAccount: 'account/getIncomeGLAccount',
      getIncomeGLByParentCategory: 'account/getIncomeGLByParentCategory',
      getStationaryAccount: 'account/getStationaryAccount',
      getCurrentFinancialDate: 'operations/getCurrentFinancialDate',
      getCorporateInformation: 'operations/getCorporateInformationList',
    })

    const fetchData = async () => {
      await getCorporateInformation({ permission: dashboardPermissions.VIEW_PFI_DASHBOARD })
      await getVaultAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'VIEW_PFI_DASHBOARD',
      })
      await getTillAccountList({
        search: '',
        page: 0,
        limit: 1000,
        permission: 'VIEW_PFI_DASHBOARD',
      })
      await getBanks({ permission: 'VIEW_PFI_DASHBOARD' })
      await getCurrentFinancialDate({ permission: 'VIEW_PFI_DASHBOARD' })
      await getBranches({
        search: '',
        page: 0,
        limit: 0,
        permission: 'VIEW_PFI_DASHBOARD',
      })
      await getIncomeGLAccount({ permission: 'VIEW_PFI_DASHBOARD' })
      await getIncomeGLByParentCategory({ permission: 'VIEW_PFI_DASHBOARD' })
      await getStationaryAccount({ permission: 'VIEW_PFI_DASHBOARD' })
    }
    onMounted(async () => {
      await fetchData()
    })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
